const search = (array, name, value) => {
  let match = false
  try {
    for (let i = 0; i < array.length; i++) {
      let element = array[i]

      if (element[name] === value) {
        match = { ...element, index: i }
        break
      }
    }
  } catch (error) {
    console.error(
      `Hubo un error al buscar "${name}" con valor "${value}" en el array "${
        Object.keys({ array })[0]
      }"`
    )
  }
  return match
}
export default search
